import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Text } from 'components/base'

export default class Breadcrump extends Component {
  static propTypes = {
    sections: PropTypes.arrayOf(PropTypes.string).isRequired,
    currentSectionIndex: PropTypes.number.isRequired,
    indexOffset: PropTypes.number,
    innerRef: PropTypes.func,
    onBack: PropTypes.func,
  }

  static defaultProps = {
    indexOffset: 1,
  }

  render() {
    return (
      <div
        className="flexbox flexbox-align-center padding-vertical-larger"
        ref={this.props.innerRef}
      >
        {this.props.sections.map((section, index) => (
          <BreadCrumbItem
            key={section}
            section={section}
            index={index + this.props.indexOffset}
            isActive={index === this.props.currentSectionIndex}
          />
        ))}

        {this.props.onBack && (
          <Text.Action onClick={this.props.onBack}>Previous step</Text.Action>
        )}
      </div>
    )
  }
}

function BreadCrumbItem({ section, index, isActive }) {
  return (
    <div
      className={classNames(
        'flexbox flexbox-align-center font-size-normal margin-right-large bold',
        {
          'shade-30': !isActive,
          'shade-05': isActive,
        }
      )}
    >
      <span
        className={classNames(
          'font-size-smaller radius-round border-small center-text inline-block margin-right-small',
          isActive ? 'shade-100 background-primary' : ''
        )}
        style={{ width: 22, height: 22, paddingTop: 3 }}
      >
        {index}
      </span>{' '}
      {section}
    </div>
  )
}
